<template>
  <div class="footer">
    <div class="container">

      <div class="footer-contact-menu">
        <div class="row">
          <div class="col-md-3 col-sm-6">
            <div class="single-footer-contact">
              <h4>{{information.title}}</h4>
              <ul>
                <li v-for="(item,i) in information.subMenu" :key="i">
                  <router-link :to="item.link">{{item.title}}</router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-3 col-sm-6">
            <div class="single-footer-contact">
              <h4>{{whyBuy.title}}</h4>
              <ul>
                <li v-for="(item,i) in whyBuy.subMenu" :key="i">
                  <router-link :to="item.link">{{item.title}}</router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-3 col-sm-6">
            <div class="single-footer-contact">
              <h4>{{myAccount.title}}</h4>
              <ul>
                <li v-for="(item,i) in myAccount.subMenu" :key="i">
                  <router-link :to="item.link">{{item.title}}</router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-3 col-sm-6">
            <div class="single-footer-contact">
              <h4>Contact</h4>
              <ul>
                <li><span>+88-123456789</span></li>
                <li><span>+88-123456789</span></li>
              </ul>
              <div class="social-icons">
                <h4>{{follow.title}}</h4>
                <ul>
                  <li v-for="(item,i) in follow.icons" :key="i">
                    <a :href="item.link" target="_blank"><i :class="item.icon"></i></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="copy_right">
        <p> &copy; 2019 OgrooSoft. All Rights Reserved </p>
      </div>

    </div>
    <div id="scroll-Top">
      <div class="return-to-top" @click="scrollToTop">
        <i class="fa fa-angle-up " id="scroll-top" data-toggle="tooltip" data-placement="top" title="" data-original-title="Back to Top" aria-hidden="true"></i>
      </div>
    </div><!--/.scroll-Top-->
  </div>
</template>


<script>
  export default {
    data () {
      return {
        information: {
          title: 'information',
          subMenu: [
            {title:'about us',link:'/about'},
            {title:'customer service',link:'/service'},
            {title:'advanced search',link:'/'},
            {title:'order and returns',link:'/cart'},
            {title:'contact us',link:'/contact'}
          ]
        },
        whyBuy: {
          title: 'why buy form us',
          subMenu: [
            {title:'about us',link:'/about'},
            {title:'customer service',link:'/service'},
            {title:'offer',link:'/offer'},
            {title:'site map',link:'/map'},
          ]
        },
        myAccount: {
          title: 'my accaount',
          subMenu: [
            {title:'sign in',link:'/login'},
            {title:'view cart',link:'/cart'},
            {title:'help',link:'/faq'}
          ]
        },
        follow: {
          title: 'follow us',
          icons:[
            {icon:'fa fa-facebook',link:'/'},
            {icon:'fa fa-twitter',link:'/'},
            {icon:'fa fa-google-plus',link:'/'},
            {icon:'fa fa-linkedin',link:'/'}
          ]
        }
      }
    },
    mounted () {
      this.scrollToTop();
    },
    methods: {
      scrollToTop() {
        $(window).on('scroll',function () {
          if ($(this).scrollTop() > 600) {
            $('.return-to-top').fadeIn();
          } else {
            $('.return-to-top').fadeOut();
          }
        });
        $('.return-to-top').on('click',function(){
            $('html, body').animate({
            scrollTop: 0
          }, 1500);
          return false;
        });
      }
    }
  }
</script>
